/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import { getCurrentInfoBox, ApricotAction } from "client/actions/infobox.ts";
import { updateUser } from "client/actions/user";
import { setOwnData } from "client/actions/own";

import { selectorCurrentInfoBox } from "client/selectors/infoboxSelector";
import { selectorPDFContent } from "client/selectors/infoboxSelector";
import { progressCircles } from "components/Form/FormField";
import { infoboxType } from "client/reducers/infoboxReducer";
import { ExMain } from "client/views/Exercise/ExMain";
import { CardViewer } from "./CardViewer";
import { HandoutViewer } from "./HandoutViewer";
import { Redirect } from "react-router-dom";

interface Props {
  getCurrentInfoBox: ApricotAction;
  updateUser: ApricotAction;
  setOwnData: ApricotAction;
  // store data
  user: any;
  currentInfoBox: any;
  pdfContent: any;
  // component props
  cid: string;
  bid: string;
  playerStarted?: boolean;
  playerPip?: boolean;
  inStudy?: boolean;
  onAction: (params: object) => void;
}

const InfoBoxMainBase: React.FC<Props> = ({
  getCurrentInfoBox,
  updateUser,
  setOwnData,
  user,
  currentInfoBox,
  pdfContent,
  cid,
  bid,
  playerStarted = false,
  playerPip = false,
  inStudy = false,
  onAction,
}: Props) => {
  useEffect(() => {
    getCurrentInfoBox(bid);
  }, [bid]);

  if (!currentInfoBox || currentInfoBox._id != bid) {
    return <div style={{ position: "fixed" }}>{progressCircles()}</div>;
  }

  const type = Number(currentInfoBox.type);
  // only HANDOUT allows video continue to play
  if (type !== infoboxType.HANDOUT) {
    onAction({ action: "pause" });
  }

  if (user && user.crs !== cid) {
    updateUser(user._id, { crs: cid }, false);
  }

  const setIboxUsage = (type: string) => {
    if (pdfContent && pdfContent.contentLink === currentInfoBox.contentLink) {
      setOwnData(user._id, cid, "x", { ibxu: { [type]: bid } }, false);
    }
  };

  switch (type) {
    case infoboxType.HANDOUT:
      setIboxUsage("hdo");
      return (
        <HandoutViewer
          playerStarted={playerStarted}
          playerPip={playerPip}
          inStudy={inStudy}
          contentLink={currentInfoBox.contentLink}
          onAction={(params: object) => onAction(params)}
        />
      );
      break;

    case infoboxType.TEST:
    case infoboxType.ASSIGNMENT:
      setIboxUsage(type === infoboxType.TEST ? "tst" : "asi");
      return currentInfoBox.exercises && currentInfoBox.exercises.length ? (
        <ExMain
          cid={cid}
          isTest={type === infoboxType.TEST}
          exercises={currentInfoBox.exercises}
          timeLimit={currentInfoBox.aux}
          points={currentInfoBox.points}
          fbk={
            (currentInfoBox.opt1 ? 0x01 : 0) | (currentInfoBox.opt2 ? 0x10 : 0)
          }
          onAction={(params: object) => onAction(params)}
        />
      ) : (
        <></>
      );
      break;

    case infoboxType.CARD:
      setIboxUsage("card");
      return (
        <CardViewer
          contentLink={currentInfoBox.contentLink}
          onAction={(params: object) => onAction(params)}
        />
      );
      break;

    default:
      return <Redirect push to="/" />;
  }
};

function mapStateToProps(state: any) {
  return {
    user: state.state_auth,
    pdfContent: selectorPDFContent(state),
    currentInfoBox: selectorCurrentInfoBox(state),
  };
}

const Base: any = InfoBoxMainBase;
export const InfoBoxMain: any = connect(mapStateToProps, {
  getCurrentInfoBox,
  updateUser,
  setOwnData,
})(Base);

export const InfoBoxMainTest = Base;
